
export enum SkillProficiency {
    Suggested = `IRC will continue to calculate the proficiency for this skill as normal.`,
    Override = `IRC will lock in your choice and ignore any subsequent assessment in calculating this skill's proficiency. The proficiency you select will remain in place until the end of the semester unless you change it.`
}